import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Card,
  CardBody,
  FormControl,
  FormErrorMessage,
  Button,
  FormLabel,
  Input,
  Heading,
  Text,
  Image,
  InputGroup,
  InputRightElement,
  useColorMode,
} from "@chakra-ui/react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "api/firebase/firebaseConfig"; // Import Firebase Firestore and authentication
import { NavLink, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { useSetRecoilState } from "recoil";
import { userState } from "states/recoil";
import { doc, getDoc } from "firebase/firestore"; // Import doc and setDoc from Firestore
import Logo from "assets/img/logo-papeda.png";
import ImageLogin from "assets/img/just-login-img.png";

const Login = () => {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const setUserState = useSetRecoilState(userState);
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const initialValues = {
    email: "",
    password: "",
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.password) {
      errors.password = "Password is required";
    } else if (values.password.length <= 7) {
      errors.password = "Password length must be more than 7";
    }

    return errors;
  };

  console.log(errors);

  const onLogin = async (values) => {
    console.log("Login button clicked");
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );
      const user = userCredential.user;

      // Fetch user data from Firestore
      const userRef = doc(db, "users", user.email);
      const userSnapshot = await getDoc(userRef);
      if (userSnapshot.exists()) {
        const userData = userSnapshot.data();
        const userLevel = userData.level;
        console.log(userData);

        // Check user level and allow or deny access
        if (userLevel === "unauthorized") {
          // User does not have permission
          setLoading(false);
          setErrors(
            "Anda sudah terdaftar namun belum diaktifkan, silakan hubungi sekretariat."
          );
        } else {
          // User has permission
          setLoading(false);

          localStorage.setItem("sessionToken", "granted");
          localStorage.setItem(
            "userInfo",
            JSON.stringify({
              email: userData.email,
              name: userData.name,
              level: userData.level,
              province: userData.province,
              id: userData.id,
            })
          );

          setUserState({
            name: userData.name,
            email: user.email,
            level: userData.level,
            province: userData.province,
            uid: user.id,
            isAuthenticated: true,
          });

          navigate("/");
          console.log(user);
        }
      } else {
        setLoading(false);
        setErrors("User data not found.");
      }
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      setErrors(errorMessage);
      setLoading(false);
      console.log(errorCode, errorMessage);
    }
  };

  useEffect(() => {
    setErrors(null);
    console.log(errors);
  }, []);
  return (
    <>
      <Flex
        direction={"row"}
        justifyContent={"space-between"}
        w={"100vw"}
        h={"100vh"}
        bg={"whiteAlpha.300"}
      >
        <Box
          // bg={'red.300'}
          w={"100%"}
          h={"100%"}
          justifyContent={"center"}
          alignItems={"center"}
          textAlign={"center"}
          alignContent={"center"}
        >
          <Image src={ImageLogin} alt={"image-login"} h={"450px"} m={"auto"} />
        </Box>
        <Flex
          w={"100%"}
          h={"100%"}
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Card
            w={"380px"}
            h={"auto"}
            mt={"-20px"}
            color={"gray.800"}
            borderRadius={"20px"}
          >
            <CardBody>
              <Flex
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                m={"32px"}
              >
                <Image src={Logo} w={"auto"} h={"90px"} alt="logo-just" />
                <Heading
                  size={"md"}
                  color={colorMode === "dark" ? "gray.100" : "gray.800"}
                  textAlign={"center"}
                >
                  Dashboard Pemantauan Penyaluran Dana Papua
                </Heading>
              </Flex>
              <Box
                h={"3px"}
                bg={colorMode === "dark" ? "rgb(63 68 78)" : "gray.100"}
                mx={"-20px"}
                my={"12px"}
              />
              <Heading
                size={"sm"}
                textAlign={"center"}
                mt={"28px"}
                mb={"20px"}
                color={colorMode === "dark" ? "gray.100" : "gray.800"}
              >
                Silakan Masuk ke Akun Anda
              </Heading>

              <Formik
                initialValues={initialValues}
                validate={validateForm}
                onSubmit={(values) => onLogin(values)}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form mt={"28px"}>
                    <FormControl isInvalid={errors.email}>
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Alamat Email
                      </FormLabel>
                      <Input
                        type="email"
                        value={values.email}
                        id="email"
                        name="email"
                        onChange={(e) => {
                          handleChange(e);
                          setErrors(null);
                        }}
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      />
                      {errors.email && touched.email && (
                        <FormErrorMessage>
                          Tolong Masukkan email Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={errors.password} mt={"20px"}>
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Password
                      </FormLabel>
                      <InputGroup>
                        <Input
                          type={show ? "text" : "password"}
                          value={values.password}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors(null);
                          }}
                          color={colorMode === "dark" ? "gray.100" : "gray.800"}
                          name="password"
                          id="password"
                        />
                        <InputRightElement width="4.5rem">
                          <Button h="1.75rem" size="sm" onClick={handleClick}>
                            {show ? "Hide" : "Show"}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {errors.password && touched.password && (
                        <FormErrorMessage>
                          Tolong Masukkan Password Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      mt={"40px"}
                    >
                      <Flex justifyContent={"start"} gap={1}>
                        <Text
                          fontSize="12px"
                          color={colorMode === "dark" ? "gray.100" : "gray.800"}
                        >
                          Belum Punya Akun?{" "}
                        </Text>
                        <NavLink
                          to="/signup"
                          className="underline text-tertiary"
                        >
                          <Text
                            color={
                              colorMode === "dark" ? "gray.100" : "gray.800"
                            }
                            fontSize="12px"
                          >
                            <u>Daftar</u>
                          </Text>
                        </NavLink>
                      </Flex>
                      <Button type="submit" colorScheme={"blue"} w={"100px"}>
                        <span>{loading ? "Memuat..." : " Masuk "}</span>
                      </Button>
                    </Flex>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
          <Box maxWidth="380px">
            <Text color="red" my="12px">
              {errors && errors}
            </Text>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default Login;
